module.exports = {
	init: function () {
		// console.log("menu.js init");
		$("#nav-toggle").on("click", function () {
			var currentExpanded = $(this).attr("aria-expanded");
			// console.log("🚀 ~ file: menu.js:7 ~ $(this):", $(this));

			$('button[aria-expanded="true"]').attr("aria-expanded", false);

			if (currentExpanded == "true") {
				$(this).attr("aria-expanded", false);
			} else {
				//* Close all other menus
				$(this).attr("aria-expanded", true);
			}

			$(".header").toggleClass("active");
			$(".header-nav").toggleClass("active");
		});

		$(".mobile-main-menu > .menu-item > a::after").on(
			"click",
			function (el) {
				$($(el).parent()).toggleClass("open");
			}
		);
	},
};
